<template>
  <textarea
    class="text-container"
    :value="value"
    :placeholder="placeholder"
    @input="onInputChange"
    @blur="onBlur"
  ></textarea>
</template>

<script>
export default {
  name: "TextField",
  data() {
    return {
      input: "",
    };
  },
  props: {
    value: String,
    onChange: Function,
    placeholder: String,
    onBlur: Function,
  },
  methods: {
    onInputChange(e) {
      this.onChange(e.target.value);
    },
  },
};
</script>

<style scoped>
.text-container {
  border: 1px solid #eaeaea;
  border-radius: 4px;
  box-sizing: border-box;
  height: 80px;
  width: 100%;
  padding: 8px;
  outline: none;
  transition: border 0.5s;
  display: flex;
  align-items: center;
  resize: none;
  color: #4a4a4a;
  -webkit-appearance: none;
}
.text-container:hover {
  border: 1px solid rgba(8, 33, 255, 0.3);
}
.text-container:focus {
  border: 1px solid #0821ff;
}
</style>
